(ns dashboard.views
  (:require
   [reagent.format :as fmt]
   [reagent.core :as r]
   [very.re-frame.core :as rf]
   [main.common :as common]
   [util.core :refer [to-local-time]]
   [cljss.core :as cljss]
   [css.core
    :as css
    :refer [get-theme defstyled]]
   [css.vars :as vars]
   [css.typography :as typo]
   [css.icons :as icons]
   [priorities.views :as priorities]))

(defstyled h2-s :h2
  {:opacity (with-meta #(or % "100%") :opacity)
   :font-weight (with-meta #(or % "400") :font-weight)
   :margin-right (with-meta #(or % "0") :margin-right)
   :color "white"
   :font-size "24px"})

(defstyled title-row-s :div
  {:display "grid"
   :grid-template-columns "max-content auto"
   :width "100%"
   :margin-bottom "20px"})

(defstyled data-row-s :div
  {:display "flex"
   :flex-direction "row"
   :justify-content "space-between"
   :margin-bottom (with-meta #(or % "15px") :margin-bottom)
   :align-items "center"})

(defstyled data-label-s :label
  {:opacity ".7"})

(defstyled data-value-s :div
  {})

(defstyled bar-row-s :div
  {:margin-bottom "20px"
   :&:last-child {:margin-bottom "0"}})

(defstyled horiz-bar-wrapper-s :div
  {:position "relative"})

(defstyled horiz-bar-s :div
  {:height "20px"
   :width (with-meta identity :width)
   :background (with-meta identity :background)
   :position "relative"
   :z-index "1"})

(defstyled horiz-bar-background-s :div
  {:position "absolute"
   :left 0
   :top 0
   :right 0
   :bottom 0
   :background "rgba(255, 255, 255, 0.1)"})

(defstyled top-divider-s :div
  {:border-bottom "1px solid rgba(255, 255, 255, .2)"
   :padding-bottom "1rem"
   :margin-bottom "1rem"})

(defstyled naked-button-s :button
  {:border "none"
   :background "none"
   :color (with-meta #(or % (get-theme :primary)) :color)
   :cursor "pointer"
   :font-size (with-meta #(or % "1rem") :font-size)
   :display "flex"
   :align-items "center"
   :padding "0"
   :transition "border .25s ease-in"
   :border-bottom "1px solid transparent"
   :&:focus {:outline "1px dotted rgba(255, 255, 255, 0.6)"
             :outline-offset "2px"}
   :&:hover {:border-bottom "1px solid rgba(255, 255, 255, 0.6)"}})

(defstyled row-s :div
  {:display "flex"
   :align-items "center"})

(defstyled chart-icon-s :div
  {:margin-right "10px"})

(defn- horiz-bar [width-percent color]
  [horiz-bar-wrapper-s
   [horiz-bar-s {:background color :width width-percent}]
   [horiz-bar-background-s]])

(defn- horiz-bar-width [numerator denominator]
  (if (= 0 denominator)
    "100%"
    (str (* 100 (min (/ (Math/abs numerator) (Math/abs denominator)) 1)) "%")))

(defn- data-row [{:keys [label value margin-bottom]}]
  [data-row-s {:margin-bottom margin-bottom}
   [data-label-s label]
   [data-value-s value]])

(defn- net-worth []
  (let [totals (rf/subscribe [:dashboard/totals])]
    (fn []
      (let [{net-worth :net-worth assets :assets liabilities :liabilities} @totals]
        [:div
         [title-row-s
          [h2-s {:opacity ".7"
                 :margin-right "1rem"} "Net worth:"]
          [h2-s {:font-weight "700"} (fmt/currency-format net-worth)]]
         [bar-row-s
          [data-row {:label "Assets:"
                     :value (str "+" (fmt/currency-format assets))}]
          [horiz-bar (horiz-bar-width assets liabilities) "#009900"]]
         [bar-row-s
          [data-row {:label "Liabilities:"
                     :value (fmt/currency-format liabilities)}]
          [horiz-bar (horiz-bar-width liabilities assets) "#F4F4F4"]]]))))

(defn- accounts-net []
  (let [nets (rf/subscribe [:dashboard/accounts-net])
        partner (rf/subscribe [:partner])]
    (fn []
      [:div
       [title-row-s
        [h2-s {:opacity ".7"
               :margin-right "1rem"} "Accounts:"]
        [h2-s {:font-weight "700"
               :data-test "dashboard-accounts-net-worth"} (fmt/currency-format (:net @nets))]]
       [data-row {:label (str (:name @partner) " held accounts:")
                  :data-test "dashboard-accounts-firm-held-net-worth"
                  :value (fmt/currency-format (:internal-net @nets))}]
       [data-row {:margin-bottom "0"
                  :label "Outside accounts:"
                  :data-test "dashboard-accounts-external-net-worth"
                  :value (fmt/currency-format (:external-net @nets))}]
       [top-divider-s]
       [naked-button-s {:font-size "12px"
                        :color "white"
                        :on-click #(rf/>evt [:navigate-to-context "/accounts"])}
        [chart-icon-s [icons/chart-white {:height "20px"
                                          :width "20px"}]]
        [:span "View my accounts"]]])))

(defstyled advisor-info-s :div
  {:display "flex"
   :align-items "flex-start"})

(defstyled advisor-picture-s :div
  {:width "75px"
   :height "75px"
   :background-color "rgba(255, 255, 255, 0.9)"
   :background-image (with-meta #(or % "url(/assets/icons/user.svg)") :image)
   :background-size "75px"
   :background-position "center"
   :background-repeat "no-repeat"
   :border-radius "100%"
   :margin-right "20px"})

(defstyled advisor-text-s :div
  {:color "white"
   :margin-bottom (with-meta #(or % "15px") :margin-bottom)})

(defstyled anchor-s :a
  {:color "white"})

(defstyled advisor-contact-s :a
  {:color "white"
   :text-decoration "none"
   :font-size ".75rem"
   :background-image (with-meta identity :icon)
   :background-size "20px 20px"
   :background-position "left top"
   :background-repeat "no-repeat"
   :padding "0 0 3px 30px"
   :line-height "20px"
   :display "inline-block"
   :margin-left "2rem"
   :transition "border .25s ease-in"
   :border-bottom "1px solid transparent"
   :&:hover {:border-bottom "1px solid rgba(255, 255, 255, 0.6)"}
   :&:focus {:outline "1px dotted rgba(255, 255, 255, 0.6)"
             :outline-offset "2px"}
   :&:first-child {:margin-left "0"}})

(defn- stringify-address-line-1 [{:keys [number prefix street street-type]}]
  (str number " "
       (when prefix
         (str prefix " "))
       street
       (when street-type
         (str " " street-type))))

(defn- stringify-address-line-2 [{:keys [city country postal state]}]
  (str (when (and city state postal)
         (str city ", " state " " postal))
       (when country
         (str " " country))))

(defn- advisor-address [address]
  (let [default-address {:city "Omaha"
                         :country nil
                         :number "123"
                         :postal "68154"
                         :prefix nil
                         :state "NE"
                         :street "California"
                         :street-type "St"}]
    (if (every? empty? (vals address))
      (advisor-address default-address)
      [:div
       [advisor-text-s (stringify-address-line-1 address)]
       [advisor-text-s (stringify-address-line-2 address)]])))

(defn- advisor-email [email]
  (let [default-email "ceosupport@carsongroup.com"]
    (if (empty? email)
      (advisor-email default-email)
      [advisor-contact-s {:href (str "mailto:" email)
                          :icon "url(/assets/icons/email.svg)"}
       "Email"])))

(defn- advisor-calendly [calendly]
  (when calendly
    [advisor-contact-s {:href calendly
                        :target "_blank"
                        :icon "url(/assets/icons/calendly.svg)"}
     "Calendly"]))

(defn- advisor-joinme [joinme]
  (when joinme
    [advisor-contact-s {:href joinme
                        :target "_blank"
                        :icon "url(/assets/icons/video-conference.svg)"}
     "JoinMe"]))

(defn- my-advisor []
  (let [advisor (rf/subscribe [:dashboard/advisor])]
    (if (not (empty? (:name @advisor)))
      [:div
       [title-row-s
        [h2-s {:opacity ".7"
               :margin-right "1rem"} "My Advisor:"]
        [h2-s {:font-weight "700"
               :data-test "dashboard-advisor-name"} (:name @advisor)]]
       [advisor-info-s
        (if (:profile-image @advisor)
          [advisor-picture-s {:image (str "url(" (:profile-image @advisor) ")")}]
          [advisor-picture-s])
        [:div
         (advisor-address (:address @advisor))
         [advisor-text-s {:margin-bottom "0"}
          [anchor-s {:href (str "tel:" (:phone @advisor))} (str "p: " (:phone @advisor))]]]]
       [top-divider-s]
       [:div
        [advisor-email (:email @advisor)]
        [advisor-calendly (:calendly-link @advisor)]
        [advisor-joinme (:joinme-link @advisor)]]])))

(defstyled todo-header-s :div
  {:display "flex"
   :padding "10px 0 50px 15px"})

(defstyled todo-header-title-s :h3
  {:cursor "pointer"
   :font-weight "700"
   :text-transform "uppercase"
   :color (with-meta #(if % (get-theme :primary) vars/text) :active?)
   :transition "color .25s ease-in"
   :&:hover {:color (get-theme :primary)}})

(defstyled todo-header-separator-s :span
  {:color vars/gray
   :padding "0 2rem"})

(defstyled todo-list-s :ul
  {:padding "0 15px"})

(defstyled todo-item-s :li
  {:display "flex"
   :justify-content "space-between"
   :align-items "center"
   :padding-bottom "20px"})

(defstyled todo-name-s :div
  {:font-weight "700"
   :height "20px"
   :line-height "20px"
   :color vars/gray
   :padding-left "35px"
   :background-image (with-meta
                       #(if (= "COMPLETE" %)
                          "url(/assets/icons/checkbox-checked.svg)"
                          "url(/assets/icons/checkbox-unchecked.svg)")
                       :status)
   :background-position "left center"
   :background-repeat "no-repeat"
   :background-size "20px"})

(defstyled todo-date-s :div
  {:display "flex"
   :align-items "center"})

(defstyled date-value-s :div
  {:margin-left "10px"
   :color vars/gray
   :text-transform "uppercase"
   :font-size "13px"})

(defn- todo-list []
  (let [todos (rf/subscribe [:dashboard/todos])
        active-list (r/atom :me)]
    (fn []
      [:div
       [common/profile-section-header {:title "To do list"}]
       [todo-header-s
        [todo-header-title-s {:on-click #(reset! active-list :me)
                              :active? (= @active-list :me)} "My Tasks"]
        [todo-header-separator-s "|"]
        [todo-header-title-s {:on-click #(reset! active-list :advisor)
                              :active? (= @active-list :advisor)} "My Advisor's Tasks"]]

       (into [todo-list-s]
             (for [t (condp = @active-list
                       :me (filter #(= (:type %) "CLIENT") @todos)
                       :advisor (filter #(= (:type %) "ADVISOR") @todos))]
               [todo-item-s
                [todo-name-s {:status (:status t)} (:subject t)]
                (when (:due-date t)
                  [todo-date-s
                   [icons/calendar]
                   [date-value-s (to-local-time (:due-date t) "MMM DD")]])]))])))

(defn- my-priorities []
  (let []
    (fn [ctx]
      (condp = ctx
        :dashboarding
        [priorities/financial-priorities
         {:on-edit #(rf/>evt [:dashboard/edit-priorities])}]

        :editing-priorities
        [priorities/manage-priorities
         {:on-save #(rf/>evt [:dashboard/update-priorities %])
          :on-cancel #(rf/>evt [:dashboard/change-context :dashboarding])}]))))

(defstyled top-grid-s :div
  {:display "grid"
   :grid-template-columns "[left-gutter-start] minmax(1rem, 1fr) [left-gutter-end content-start] minmax(min-content, 82rem) [content-end right-gutter-start] minmax(1rem, 1fr) [right-gutter-end]"
   :background (get-theme :primary)
   :padding "65px 0 75px"})

(defstyled dashboard-s :div
  {:display "grid"
   :grid-column "span 3"
   :grid-template-rows "min-content"})

(defstyled top-section-s :section
  {:display "grid"
   :grid-column "content"
   :grid-template-columns "4fr min-content 5fr"
   :grid-gap "8%"
   :color "white"
   ::cljss/media {[[:max-width "1100px"]]
                  {:grid-template-columns "1fr 1fr"
                   :grid-gap "60px"}
                  [[:max-width "768px"]]
                  {:grid-template-columns "1fr"}}})

(defstyled bottom-grid-s :div
  {:display "grid"
   :grid-template-columns "[left-gutter-start] minmax(1rem, 1fr) [left-gutter-end content-start] minmax(min-content, 82rem) [content-end right-gutter-start] minmax(1rem, 1fr) [right-gutter-end]"
   :padding "75px 0"})

(defstyled bottom-section-s :section
  {:display "grid"
   :grid-column "content"
   :grid-template-columns "1fr 1fr"
   :grid-gap "2.5rem"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr"}}})

(defn dashboard []
  (let [ctx (rf/subscribe [:dashboard/context])]
    (fn []
      (condp = @ctx
        :dashboarding
        [dashboard-s {:data-test "dashboard-page"}
         [top-grid-s
          [top-section-s
           [net-worth]
           [accounts-net]
           [my-advisor]]]
         [bottom-grid-s
          [bottom-section-s
           [todo-list]
           [my-priorities @ctx]]]]

        :editing-priorities
        [my-priorities @ctx]

        [common/loading-s
         [common/loading-body-s
          [typo/h1 "Loading Dashboard..."]]]))))
